import React from 'react';
import { Grid } from '@mui/material';
import { paddingStyles } from '../../constants/theme/styles/layout/paddingStyles';

interface Props {
   
}
export const PageContainer = (props: React.PropsWithChildren<Props>) => {
    const classes = paddingStyles();
    return (
        <>
            <div className={`${classes.containerPadding} limited-page-width`}>
                <Grid container>
                    {props.children}
                </Grid>
            </div>
        </>
    );
};